import { Avatar } from "@shared/ui";
import styles from "./styles.module.scss";

const AVATAR_TONES = [
  "violet",
  "teal",
  "blue",
  "pink",
  "amber",
  "orange",
] as const;

type PayoutCreatorCellProps = {
  name?: string;
  handle?: string;
  profileUrl?: string;
};

function getAvatarTone(value: string) {
  const sum = [...value].reduce((total, char) => total + char.charCodeAt(0), 0);
  return AVATAR_TONES[sum % AVATAR_TONES.length];
}

function getInitials(name?: string) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "C";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export function PayoutCreatorCell({
  name,
  handle,
  profileUrl,
}: PayoutCreatorCellProps) {
  const displayName = name || handle || "Creator";
  const displayHandle = handle
    ? handle.startsWith("@")
      ? handle
      : `@${handle}`
    : undefined;
  const tone = getAvatarTone(displayName);

  return (
    <button
      type="button"
      className={styles.cell}
      onClick={() => {
        if (profileUrl) window.open(profileUrl, "_blank");
      }}
    >
      <Avatar size={32} className={`${styles.avatar} ${styles[tone]}`}>
        {getInitials(displayName)}
      </Avatar>
      <span className={styles.meta}>
        <span className={styles.name}>{displayName}</span>
        {displayHandle ? (
          <span className={styles.handle}>{displayHandle}</span>
        ) : null}
      </span>
    </button>
  );
}
